export default __webpack_public_path__ + "static/wo-4373e9b5e16822f47bd169c173faa66d.gif";